import styled from "styled-components";

const S = {
    PageWrapper: styled.div`
        background: #f8fafc;
        min-height: 100vh;
        padding-bottom: 80px;
    `,
    HeroSection: styled.section`
        background: linear-gradient(135deg, #00A9C4 0%, #00798c 100%);
        padding: 80px 20px;
        text-align: center;
        color: white;

        @media (max-width: 768px) {
            padding: 40px 16px;
        }

        .hero-content {
            max-width: 800px;
            margin: 0 auto;

            h1 {
                font-size: 3.5em;
                font-weight: 800;
                margin: 0 0 20px 0;
                letter-spacing: -1px;

                @media (max-width: 768px) {
                    font-size: 2.2em;
                }

                @media (max-width: 480px) {
                    font-size: 1.75em;
                }
            }
        }
    `,
    Breadcrumb: styled.div`
        display: flex;
        align-items: center;
        justify-content: center;
        flex-wrap: wrap;
        gap: 10px;
        font-size: 1.1em;
        opacity: 0.9;

        @media (max-width: 768px) {
            font-size: 0.95em;
            gap: 6px;
        }
        
        a {
            color: white;
            text-decoration: none;
            font-weight: 500;
            transition: opacity 0.2s ease;
            
            &:hover {
                opacity: 0.7;
            }
        }
        
        .separator {
            font-size: 0.9em;
            opacity: 0.6;
        }
    `,
    ContentWrapper: styled.div`
        max-width: 1400px;
        margin: -40px auto 0;
        padding: 0 20px;
        display: flex;
        flex-direction: column;
        gap: 50px;
        position: relative;
        z-index: 10;
        box-sizing: border-box;

        @media (max-width: 768px) {
            margin: -24px auto 0;
            padding: 0 12px;
            gap: 24px;
        }

        /* GENERAL CARD STYLING */
        .data-card {
            background: #ffffff;
            border-radius: 20px;
            box-shadow: 0 10px 30px rgba(0, 0, 0, 0.05);
            border: 1px solid rgba(0,0,0,0.05);
            padding: 40px;
            box-sizing: border-box;
            
            @media (max-width: 768px) {
                padding: 24px 16px;
                border-radius: 16px;
            }
        }
    `,
    TextSection: styled.section`
        .text-content {
            max-width: 900px;
            margin: 0 auto;
            
            h2 {
                font-size: 2em;
                color: #1e293b;
                margin-top: 0;
                margin-bottom: 30px;
                font-weight: 800;
                text-align: center;

                @media (max-width: 768px) {
                    font-size: 1.4em;
                    margin-bottom: 18px;
                }
            }

            .article-body {
                font-size: 1.1em;
                line-height: 1.8;
                color: #334155;

                @media (max-width: 768px) {
                    font-size: 1em;
                    line-height: 1.65;
                }
                
                p {
                    margin-bottom: 24px;

                    @media (max-width: 768px) {
                        margin-bottom: 16px;
                    }
                }

                .quote-block {
                    border-left: 4px solid #00A9C4;
                    padding: 20px 30px;
                    margin: 30px 0;
                    background: #f0fbfc;
                    border-radius: 0 12px 12px 0;

                    @media (max-width: 768px) {
                        padding: 14px 16px;
                        margin: 20px 0;
                    }
                    
                    p {
                        margin: 0;
                        font-size: 1.15em;
                        font-style: italic;
                        color: #0f172a;
                        font-weight: 500;

                        @media (max-width: 768px) {
                            font-size: 1em;
                        }
                    }
                }
            }
        }
    `,
    GallerySection: styled.section`
        .gallery-header {
            text-align: center;
            margin-bottom: 40px;

            @media (max-width: 768px) {
                margin-bottom: 24px;
            }
            
            h2 {
                font-size: 2.2em;
                color: #1e293b;
                margin: 0 0 10px 0;
                font-weight: 800;

                @media (max-width: 768px) {
                    font-size: 1.5em;
                }
            }
            
            p {
                font-size: 1.1em;
                color: #64748b;
                margin: 0;

                @media (max-width: 768px) {
                    font-size: 0.95em;
                }
            }
        }

        .mapContainer {
            display: grid;
            grid-template-columns: repeat(auto-fill, minmax(320px, 1fr));
            gap: 25px;

            @media (max-width: 768px) {
                grid-template-columns: 1fr;
                gap: 16px;
            }

            .iframe-card {
                background: #ffffff;
                border-radius: 16px;
                overflow: hidden;
                box-shadow: 0 4px 15px rgba(0,0,0,0.04);
                transition: transform 0.3s ease, box-shadow 0.3s ease;
                border: 1px solid rgba(0,0,0,0.03);
                height: 250px;

                @media (max-width: 600px) {
                    height: 210px;
                    border-radius: 14px;
                }

                &:hover {
                    transform: translateY(-5px);
                    box-shadow: 0 15px 30px rgba(0,169,196,0.15);
                }

                iframe {
                    width: 100%;
                    height: 100%;
                    border: none;
                    pointer-events: auto;
                }
            }
        }
    `
};

export default S;